<div [@slide]="{ value: state, params: { speed: animSpeed } }" #slideElement>
  <ng-content></ng-content>
</div>
